import {Contract} from 'ethers';
import {Interface} from '@ethersproject/abi';
import {useCallback} from 'react';
import {useEthers} from '@usedapp/core';
import {useScopeTranslation} from '@uigstudio/uig-nextjs-helper';

import PlotNFTAbi from '~abi/MintPlotNFT.json';
import {MintPlotNFT} from '~abiTypes/MintPlotNFT';
import useContractWrite from '~hooks/useContractWrite';
import useFetchPlotProof from '~api/useFetchPlotProof';
import env from '~utils/env';

const contract = new Contract(
    env('MINT_PLOT_ADDRESS'),
    new Interface(PlotNFTAbi),
) as MintPlotNFT;

const useMintPlotNFT = (id: number) => {
    const t = useScopeTranslation('common', 'mint');
    const {account} = useEthers();

    const [claimNFT, mintLoading] = useContractWrite(
        contract,
        'claimNFT',
        {transactionName: t('title')},
        {
            errorTitle: t('errorTitle'),
            successMessage: t('successMessage'),
            successTitle: t('successTitle'),
        },
    );
    const {data: proof, isLoading: proofLoading} = useFetchPlotProof(id);
    const mintPlot = useCallback(async () => {
        if (account && proof) {
            await claimNFT(id, account, proof.proof);
        }
    }, [claimNFT, proof, id]);

    return {mintPlot, mintLoading, proofLoading, proof};
};
export default useMintPlotNFT;
